import { AssetTypeRepository } from '@telespot/domain';

export interface IDeleteAssetTypeCommand {
  /**
   * Deletes the asset type with the given id.
   * Repository errors propagate so callers can decide how to react.
   */
  execute(assetTypeId: string): Promise<void>;
}

export class DeleteAssetTypeCommand implements IDeleteAssetTypeCommand {
  constructor(private readonly assetTypeRepository: AssetTypeRepository) {}

  public async execute(assetTypeId: string): Promise<void> {
    await this.assetTypeRepository.delete(assetTypeId);
  }
}
